export default __webpack_public_path__ + "static/media/Snd_b4.05ead1c0.mp3";